
import { defineComponent } from 'vue';
import { NButton } from '@/uikit';

export default defineComponent({
  name: 'LoginCryptoProForm',
  components: { NButton }
});
